import React, { useState } from "react";
import OtpInput from "react-otp-input";
import styles from "./OtpInput.module.scss";
import { ModalComponent } from "../Modal/Modal";
import { Spinner } from "react-bootstrap";
import { PrimaryButton } from "../Button/Button";

export default function OTPComponent({
  numInputs = 6,
  onComplete,
  separator,
  isModalOpen,
  handleClose,
  spinner,
  handleResendOtp
}) {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [otpStatus, setOtpStatus] = useState(""); // 'error' or 'success'

  const handleChange = (otp) => {
    setOtp(otp);
    setError(""); // Clear error on input change
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const data = event.clipboardData.getData("Text").replace(/[^0-9]/g, "");
    if (data.length <= numInputs) {
      setOtp(data);
    }
  };

  const validateOtp = () => {
    if (otp.length !== numInputs) {
      setError("OTP is required");
      setOtpStatus("error");
    } else {
      // Simulate OTP validation (success)
      setOtpStatus("success");
      onComplete(otp);
    }
  };

  const handelResend = () => {
    setOtp(""); // Reset OTP input
    setError(""); // Clear any errors
    setOtpStatus(""); // Reset OTP status
    // Add logic to resend OTP (e.g., API call)
    //handleResendOtp()
  };

  const handleKeyDown = (event) => {
    // Validate OTP when Enter key is pressed
    
      validateOtp();
    
  };

  return (
    <div className={styles.otpContainer}>
      <ModalComponent
        open={isModalOpen}
        onClose={handleClose}
        className={styles.otpModal}
      >
        <div className={styles.otpContent}>
          <p className={`${styles.otpTitle} text-center`}>
            Enter Verification Code
          </p>
          <p className={styles.modalSubtitle}>
            Please check your email or phone for the OTP and enter it below.
          </p>

          <div>
            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={numInputs}
              separator={<span className={styles.separator}>{separator}</span>}
              isInputNum={true}
              renderInput={(props) => (
                <input
                  {...props}
                  className={`${styles.otpInput} 
                    ${otpStatus === 'error' ? styles.inputError : ''} 
                    ${otpStatus === 'success' ? styles.inputSuccess : ''}`}
                  onPaste={handlePaste}
                  onKeyDown={handleKeyDown} // Listen for Enter key press
                />
              )}
            />
            {error && <p className={styles.errorMessage}>{error}</p>}
          </div>
          {true&&<PrimaryButton className={styles.resendButton} onClick={validateOtp} spinner={spinner} label="Verify OTP"/>}
        </div>
      </ModalComponent>
    </div>
  );
}
